<div class="home-background">
  <qm-toolbar></qm-toolbar>
  <div class="left-sidebar">
    <div class="controls d-flex flex-wrap">
      <div class="d-flex btn-group-vertical control-panel-left">
        <ng-template ngFor let-item let-i="index" [ngForOf]="sidebarPanels">
          <ng-container *ngIf="item.showOnSidebar">
            <button [attr.data-btnId]="getElementId('togglePanel_' + item.panel)"
                    ngbTooltip="{{ item.title | translate}}" (click)="toggleTileVisible(item)"
                    class="btn btn-outline-info" title="" *qmAuth="item.panel">
              <i [class]="item.icon + ' fa-lg'" [attr.data-fa-transform]="item.iconDataFaTransform"
                 *ngIf="item.panel !== 'vivo'; else vivo"></i>
              <div *ngIf="item.panel === 'alarm-list' && (activeAlarmsLength | async) > 0" class="button-notification-count">{{ activeAlarmsLength | async }}</div>
            </button>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="right-sidebar" *ngIf="isMapReady">
    <div class="controls d-flex flex-wrap">
      <qm-view-settings></qm-view-settings>
      <qm-controls></qm-controls>
    </div>
  </div>

  <div class="home-container">
    <gridster [options]="options">
      <gridster-item [item]="item" *ngFor="let item of dashboard">
        <div class="card" style="width: 100%; height: 100%">
          <div class="card-title-container">
            <h5 class="card-title drag-handler">
              <ng-container *ngIf="item.titleTemplate; else plainTitle">
                <ng-container *ngTemplateOutlet="item.titleTemplate"></ng-container>
              </ng-container>
              <ng-template #plainTitle>
                {{item.title | translate}}
              </ng-template>
            </h5>
            <div class="action-buttons">
              <a [attr.data-btnId]="getElementId('restore_' + item.panel)" class="text-success" *ngIf="item.maximized"
                 (click)="restoreTile($event, item)">
                <i class="far fa-xs fa-window-restore"></i>
              </a>
              <a [attr.data-btnId]="getElementId('maximize_' + item.panel)" class="text-success"
                 *ngIf="!item.maximized" (click)="maximizeTile($event, item)">
                <i class="far fa-xs fa-window-maximize"></i>
              </a>
              <a [attr.data-btnId]="getElementId('close_' + item.panel)" class="text-danger"
                 (click)="removeTile($event, item)">
                <i class="far fa-xs fa-window-close"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <ng-container *ngComponentOutlet="item.component; injector: getInjectorForPanel | applyFunction:item"></ng-container>
          </div>
        </div>
      </gridster-item>
    </gridster>
  </div>
  <div class="map">
    <qm-mapbox (mapReady)="onMapReady()"></qm-mapbox>
  </div>

  <qm-vrgroup-base *qmAuth="'vr-group'"></qm-vrgroup-base>
  <!-- FIXME: if -->
  <qm-neve-base *ngIf="this.getTenant() === 14"></qm-neve-base>
  <qm-joensuu-base  *ngIf="this.getTenant() === 13"></qm-joensuu-base>
</div>
<qm-notification-types *qmAuth="'button_write'"></qm-notification-types>

<ng-template #vivo>
  <span style="font-size: 0.95rem; position: relative; top: 0.5rem;">
    VIVO
  </span>
</ng-template>
<ng-template #inactive>
  <span class="inactive-panel"></span>
</ng-template>
